import { QueryParameters, SortOption } from '@standardkit/core';

export function mapSort<T>(sort: SortOption<T>[] = []): QueryParameters {
  const parameters: QueryParameters = {};

  sort?.forEach((sortOption: SortOption<T>) => {
    parameters[`sort[${sortOption.field}]`] = sortOption.order;
  });

  return parameters;
}
